import { render } from "./SaleReport.vue?vue&type=template&id=0b755488"
import script from "./SaleReport.vue?vue&type=script&lang=js"
export * from "./SaleReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__